/* global Modernizr */
import React, { PureComponent } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import diff from 'deep-diff';
import { ShareButtons } from 'react-share';

import Twemoji from 'twemoji';
import hasEmoji from '../../lib/emoji';

import VideoPlayer from './VideoPlayer.jsx';
import Extras from '../../data/extras.json';
import AnimatedEllipsis from './AnimatedEllipsis.jsx';
import { sendEvent } from '../../lib/analytics';

let reachedEnd = false;
const showEmoji = !hasEmoji();
// const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

const propTypes = {
    debug: PropTypes.bool.isRequired,
    message: PropTypes.object,
    nextMessage: PropTypes.object,
    index: PropTypes.number.isRequired,
    nextIndex: PropTypes.number.isRequired,

    answers: PropTypes.array.isRequired,
    currentMessages: PropTypes.array.isRequired,

    current: PropTypes.bool.isRequired,
    isAnimated: PropTypes.bool.isRequired,
    isLeon: PropTypes.bool,
    play: PropTypes.bool,
    expanded: PropTypes.bool,
    loadingTime: PropTypes.number,

    onMessageClick: PropTypes.func.isRequired,
    onAnswerClick: PropTypes.func.isRequired,
};

const defaultProps = {
    message: null,
    nextMessage: null,
    index: 0,
    nextIndex: 0,

    isLeon: true,
    isAnimated: false,
    play: true,
    expanded: false,
    loadingTime: 3.2,
};

const contextTypes = {
    language: PropTypes.string,
};

const {
    FacebookShareButton,
} = ShareButtons;

class Message extends PureComponent {

    static onPreventStop(e) {
        if (e) {
            e.stopPropagation();
        }
    }

    static getColor(message) {
        const {
            character,
            command,
            crisis,
            color,
            crash,
            learnMore,
        } = message;
        let messageColor = 'white';

        switch (character) {
        case 'Leon':
        case 'LeonGif':
            messageColor = 'white';
            break;
        case 'Choix':
            messageColor = 'yellow';
            break;
        case 'Share':
        case 'Partage':
            messageColor = 'yellow';
            break;
        default:
            messageColor = 'white';
        }

        if (command === true || crisis === true) {
            messageColor = 'yellow';
        }

        if (color !== null) {
            messageColor = color;
        }

        if (crisis === true || crash === true) {
            messageColor = 'black';
        }

        if (learnMore !== null) {
            messageColor = 'yellow';
        }

        return messageColor;
    }

    constructor(props) {
        super(props);
        const { isAnimated } = props;

        this.loadingTimer = null;

        this.videoRef = null;

        this.onTogglePlayVideo = this.onTogglePlayVideo.bind(this);

        const display = !isAnimated;
        this.state = {
            display,
            videoPlaying: false,
        };
    }

    componentDidMount() {
        const { isAnimated, loadingTime, message } = this.props;

        if (isAnimated) {
            this.loadingTimer = setTimeout(() => {
                this.setState({
                    display: true,
                });
            }, loadingTime * 1000);
        }

        if (message && message.key === 'C_5_Leon_40.0' && reachedEnd === false) {
            sendEvent('position', 'end_menu');
            reachedEnd = true;
            // console.log('reached_end');
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { videoPlaying } = this.state;
        const videoPlayingChanged = prevState.videoPlaying !== videoPlaying;

        if (videoPlayingChanged && this.videoRef !== null) {
            if (videoPlaying) {
                this.videoRef.play();
            } else {
                this.videoRef.pause();
            }
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this.props.message.key !== nextProps.message.key
            || this.state.display !== nextState.display
            || this.props.current !== nextProps.current;
            // || this.props.answers.length !== nextProps.answers.length;
    }

    onTogglePlayVideo() {
        if (this.videoRef !== null) {
            this.setState({
                videoPlaying: !this.state.videoPlaying,
            });
        }
    }

    createEvents(message) {
        // Events
        const userEvents = {};
        let callback = null;

        if (message.command === true || message.learnMore !== null) {
            if (Modernizr.touchevents) {
                userEvents.onTouchStart = Message.onPreventStop;
                userEvents.onTouchMove = Message.onPreventStop;
                userEvents.onTouchEnd = Message.onPreventStop;
            } else {
                userEvents.onMouseDown = Message.onPreventStop;
                userEvents.onMouseMove = Message.onPreventStop;
                userEvents.onMouseUp = Message.onPreventStop;
                userEvents.onWheel = Message.onPreventStop;
            }

            if (message.nextScene !== null) {
                callback = _.bind((e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.props.onMessageClick(e, 'nextScene');
                }, this);
            } else if (message.nextChapter !== null) {
                callback = _.bind((e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.props.onMessageClick(e, 'nextChapter', message.nextChapter);
                }, this);
            } else if (message.learnMore !== null) {
                callback = _.bind((e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.props.onMessageClick(e, 'learnMore', message.learnMore);
                }, this);
            }

            if (Modernizr.touchevents) {
                userEvents.onTouchEnd = callback;
            } else {
                userEvents.onMouseUp = callback;
            }
        }

        return userEvents;
    }

    renderButton(message, index) {
        const { current, answers, play } = this.props;
        const { language } = this.context;
        if (!message || !message.text) return null;

        const nextIndex = this.props.currentMessages.map(o => (o.key)).indexOf(message.next);
        const key = `choice-${index}-${message.key}`;
        let text = message.text[language] || '';

        let frozen = false;
        let done = false;

        if (!current && answers.indexOf(message.key) === -1) {
            done = true;
        }

        if (!play) {
            frozen = true;
        }

        // Events on answer
        let userEvents = {};
        if (Modernizr.touchevents) {
            userEvents.onTouchStart = Message.onPreventStop;
            userEvents.onTouchMove = Message.onPreventStop;
            userEvents.onTouchEnd = Message.onPreventStop;
        } else {
            userEvents.onMouseDown = Message.onPreventStop;
            userEvents.onMouseMove = Message.onPreventStop;
            userEvents.onMouseUp = Message.onPreventStop;
            // userEvents.onWheel = Message.onPreventStop;
        }

        let callback = null;
        if (message.learnMore !== null) {
            callback = (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.props.onMessageClick(e, 'learnMore', message.learnMore);
            };
        } else if (message.share === true) {
            // No callbacks here
        } else {
            callback = (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.props.onAnswerClick(e, message.key, nextIndex, index + 1);
            };
        }

        if (current && !done && play) {
            if (Modernizr.touchevents) {
                userEvents.onTouchEnd = callback;
            } else {
                userEvents.onMouseUp = callback;
            }
        }

        const className = classNames({
            'message-content': true,
            'message-choice': true,
            'message-done': done,
            'message-frozen': frozen,
            'message-chosen': !done && !current && play,
            btn: true,
        });

        if (callback === null) {
            userEvents = {};
        }

        if (showEmoji) {
            text = Twemoji.parse(text);
        }

        return callback === null ? (
            <div
                key={key}
                className={className}
            >
                { message.share === true ? (
                    this.renderShare(text)
                ) : (
                    <span
                        className="real-content"
                        dangerouslySetInnerHTML={{ __html: text }}
                    />
                ) }
                <div className="fake-content">
                    <AnimatedEllipsis />
                </div>
            </div>
        ) : (
            <button
                key={key}
                className={className}
                {...userEvents}
            >
                { message.share === true ? (
                    this.renderShare(text)
                ) : (
                    <span
                        className="real-content"
                        dangerouslySetInnerHTML={{ __html: text }}
                    />
                ) }
                <div className="fake-content">
                    <AnimatedEllipsis />
                </div>
            </button>
        );
    }

    // eslint-disable-next-line class-methods-use-this
    renderTypingMessage(className, userEvents) {
        return (
            <div className="typing-message" >
                <div className={className}>
                    <div className="message-content" {...userEvents}>
                        <AnimatedEllipsis />
                    </div>
                </div>
            </div>
        );
    }

    // eslint-disable-next-line class-methods-use-this
    renderImage(src, userEvents, classn = 'gif') {
        const className = classn === 'gif' ? 'message-content btn notpointable' : 'message-content btn';

        return (
            <div className="inner-animated">
                <button className={className} {...userEvents}>
                    <div className="real-content">
                        <img
                            src={src}
                            alt="agif"
                            className={`message-content ${classn}`}
                        />
                        { classn === 'pointable' ? (
                            <div className="video-play-button" />
                        ) : null }
                    </div>
                    <div className="fake-content">
                        <AnimatedEllipsis />
                    </div>
                </button>
            </div>
        );
    }

    renderVideo(media, userEvents) {
        if (!media) return null;

        return (
            <div className="inner-animated">
                <div className="message-content btn">
                    <VideoPlayer name={media} paused={!this.props.current} canMute />
                    <div className="fake-content">
                        <AnimatedEllipsis />
                    </div>
                </div>
            </div>
        );
    }

    // eslint-disable-next-line class-methods-use-this
    renderShare(text) {
        const link = `${window.location.protocol}//${window.location.hostname}`;
        return (
            <FacebookShareButton
                url={link}
                quote={`${document.title} - ${text}`}
            >
                { text }
            </FacebookShareButton>
        );
    }

    // eslint-disable-next-line class-methods-use-this
    renderText(crash, text, userEvents) {
        let txt = text;
        if (showEmoji) {
            txt = Twemoji.parse(text);
        }
        if (crash) {
            txt = `<img src="/img/common/crash-dotmatrix.svg" /><br />${text}`;
        }
        // console.log('text', text);
        return (
            <div className="inner-animated">
                <button
                    className="message-content btn"
                    {...userEvents}
                >
                    <span
                        className="real-content"
                        dangerouslySetInnerHTML={{ __html: txt }}
                    />
                    <div className="fake-content">
                        <AnimatedEllipsis />
                    </div>
                </button>
            </div>
        );
    }

    renderContent() {
        const {
            message,
            nextMessage,
            isLeon,
            visible,
            current,
        } = this.props;

        const { display } = this.state;
        const { language } = this.context;

        let text = message.text[language] || '';
        const media = message.media[language] || '';
        // console.log('media', media);

        const color = Message.getColor(message);
        const isImage = media.type === 'gif';
        const isVideo = typeof message.video !== 'undefined';
        const learnMore = message.learnMore !== null ? true : false;

        // const isThumbUp = text.indexOf('(Thumb up)') > -1;
        let isGraph = false;
        let lmImage = null;

        const userEvents = this.createEvents(message);

        let type = 'content';
        let buttons = null;
        let crash = false;

        if (isImage) {
            type = 'image';
        }

        if (message.crash === false) {
            if (nextMessage !== null && nextMessage.crash === true) {
                crash = true;
            }
        }

        if (message.choice === true && message.choices && message.choices.length > 0) {
            type = 'choice';
            buttons = message.choices.map((obj, idx) => (
                this.renderButton(obj, idx)
            ));
        }

        if (message.key.indexOf('Graph') > -1 || message.key.indexOf('SavoirPlus') > -1) {
            isGraph = true;
        }

        const className = classNames({
            message: true,
            current,
            // hidden: !this.props.play,
            expanded: this.props.expanded === true,
            crash: message.crash,
            'yellow-border': !isLeon,
            'image-only': isImage || isGraph,
            [`type-${type}`]: true,
            [`color-${color}`]: true,
            'loading-message': !display,
        });

        if (learnMore) {
            lmImage = `/video/jpg/${message.learnMore}-${this.context.language}.jpg`;
        }

        let content = null;
        if (message.nextScene) {
            content = null;
        } else if (learnMore) {
            content = this.renderImage(lmImage, userEvents, 'pointable');
        } else if (isImage) {
            content = this.renderImage(media.src, userEvents);
        } else if (isVideo) {
            content = this.renderVideo(message.video, userEvents, message);
        } else {
            content = this.renderText(crash, text, userEvents);
        }

        return (
            <li className={className}>
                { content }
                { buttons !== null ? (
                    <div className="choices">
                        <div className="inner-animated">
                            { buttons }
                        </div>
                    </div>
                ) : null}
            </li>
        );
    }

    render() {
        return this.renderContent();
    }

}

Message.propTypes = propTypes;
Message.defaultProps = defaultProps;
Message.contextTypes = contextTypes;

module.exports = Message;



// WEBPACK FOOTER //
// ./js/components/partials/Message.jsx